import React, { useEffect, useState } from "react";
import ReservationForm from "./ReservationForm";
import { getStoreOptions, createGuestReservation, getGuestReservation, cancelGuestReservation } from "../api/reservation";
import { reservationStatusLabel, isCancellable } from "../utils/reservationStatus";

/** 비회원(로그인 없이) 예약 신청 + 예약번호/연락처로 조회·취소. */
export default function GuestReservationPanel({ onGoLogin }) {
  const [tab, setTab] = useState("new"); // 'new' | 'lookup'
  const [storeOptions, setStoreOptions] = useState([]);
  const [savedReservation, setSavedReservation] = useState(null);

  const [lookupId, setLookupId] = useState("");
  const [lookupPhone, setLookupPhone] = useState("");
  const [lookupResult, setLookupResult] = useState(null);
  const [lookupError, setLookupError] = useState("");
  const [lookupLoading, setLookupLoading] = useState(false);

  useEffect(() => {
    getStoreOptions().then((res) => setStoreOptions(res.data || [])).catch(() => setStoreOptions([]));
  }, []);

  const handleSubmit = async (payload) => {
    const res = await createGuestReservation(payload);
    setSavedReservation(res.data);
  };

  const handleLookup = async (e) => {
    e.preventDefault();
    setLookupError("");
    setLookupResult(null);
    if (!lookupId || !lookupPhone.trim()) {
      setLookupError("예약번호와 연락처를 입력하세요.");
      return;
    }
    setLookupLoading(true);
    try {
      const res = await getGuestReservation(Number(lookupId), lookupPhone.trim());
      setLookupResult(res.data);
    } catch (err) {
      setLookupError(err.response?.data?.message || "예약 정보를 찾을 수 없습니다.");
    } finally {
      setLookupLoading(false);
    }
  };

  const handleCancel = async () => {
    if (!window.confirm("이 예약을 취소하시겠습니까?")) return;
    try {
      await cancelGuestReservation(lookupResult.reservationId, lookupPhone.trim());
      handleLookup({ preventDefault: () => {} });
    } catch (err) {
      window.alert(err.response?.data?.message || "취소에 실패했습니다.");
    }
  };

  return (
    <div className="reservation-panel guest-reservation-panel">
      <div className="reservation-tabs">
        <button className={tab === "new" ? "active" : ""} onClick={() => setTab("new")}>비회원 예약 신청</button>
        <button className={tab === "lookup" ? "active" : ""} onClick={() => setTab("lookup")}>예약 조회/취소</button>
      </div>

      {tab === "new" && (
        <>
          {savedReservation && (
            <div className="reservation-saved-notice">
              예약이 접수되었습니다. <strong>예약번호 {savedReservation.reservationId}</strong> 를 꼭 기억해두세요.
              (예약 조회/취소 시 예약번호와 연락처가 필요합니다.)
            </div>
          )}
          <ReservationForm storeOptions={storeOptions} guestFields onSubmit={handleSubmit} />
        </>
      )}

      {tab === "lookup" && (
        <div>
          <form className="reservation-form" onSubmit={handleLookup}>
            <div className="reservation-form-row">
              <div>
                <label>예약번호</label>
                <input type="number" value={lookupId} onChange={(e) => setLookupId(e.target.value)} required />
              </div>
              <div>
                <label>연락처</label>
                <input value={lookupPhone} onChange={(e) => setLookupPhone(e.target.value)} placeholder="010-0000-0000" required />
              </div>
            </div>
            {lookupError && <p className="error">{lookupError}</p>}
            <button type="submit" disabled={lookupLoading}>{lookupLoading ? "조회 중..." : "조회"}</button>
          </form>

          {lookupResult && (
            <div className="reservation-card" style={{ marginTop: 16 }}>
              <div className="reservation-card-top">
                <strong>{lookupResult.storeName}</strong>
                <span className={`status-tag status-${lookupResult.reservationStatus}`}>{reservationStatusLabel(lookupResult.reservationStatus)}</span>
              </div>
              <div className="text-sub">{lookupResult.reservationDate} {(lookupResult.reservationTime || "").slice(0, 5)} · {lookupResult.partySize}명</div>
              {lookupResult.requestMemo && <div className="text-sub">요청사항: {lookupResult.requestMemo}</div>}
              {lookupResult.adminMemo && <div className="text-sub">매장 메모: {lookupResult.adminMemo}</div>}
              {isCancellable(lookupResult.reservationStatus) && (
                <button className="link-btn" onClick={handleCancel}>예약 취소</button>
              )}
            </div>
          )}
        </div>
      )}

      {onGoLogin && (
        <p className="auth-switch">
          회원이신가요? <button type="button" className="link-btn" onClick={onGoLogin}>로그인하고 예약하기</button>
        </p>
      )}
    </div>
  );
}
